import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index.vue'),
    hidden: true
  },
  {
    path: '/register',
    component: () => import('@/views/login/register.vue'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '/account',
    name:'account',
    component:Layout,
    hidden: true,
    children:[{
      path: 'accountInfo',
        name: 'accountInfo',
        component: () => import('@/views/ums/account/index.vue'),
        meta: {
          title: '我的账号',
          icon: 'home'
        }
    }]    
  },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/teacheSource',
  //   children: [
  //     {
  //       path: 'teacheSource',
  //       name: 'teacheSource',
  //       component: () => import('@/views/teacheSource/index.vue'),
  //       meta: {
  //         title: '教学资源系统',
  //         icon: 'home'
  //       }
  //     },
      
  //   ]
  // }
]

export const asyncRouterMap = [
  // {
  //   path: '/ums',
  //   component: Layout,
  //   redirect: '/ums/admin',
  //   name: 'ums',
  //   meta: {title: '权限', icon: 'ums'},
  //   children: [{
  //     path: 'admin',
  //     name: 'admin',
  //     component: () => import('@/views/ums/admin/index'),
  //     meta: {title: '用户列表', icon: 'ums-admin'}
  //   }, {
  //     path: 'role',
  //     name: 'role',
  //     component: () => import('@/views/ums/role/index'),
  //     meta: {title: '角色列表', icon: 'ums-role'}
  //   }, {
  //     path: 'allocMenu',
  //     name: 'allocMenu',
  //     component: () => import('@/views/ums/role/allocMenu'),
  //     meta: {title: '分配菜单'},
  //     hidden: true
  //   }, {
  //     path: 'allocResource',
  //     name: 'allocResource',
  //     component: () => import('@/views/ums/role/allocResource'),
  //     meta: {title: '分配资源'},
  //     hidden: true
  //   }, {
  //     path: 'menu',
  //     name: 'menu',
  //     component: () => import('@/views/ums/menu/index'),
  //     meta: {title: '菜单列表', icon: 'ums-menu'}
  //   }, {
  //     path: 'addMenu',
  //     name: 'addMenu',
  //     component: () => import('@/views/ums/menu/add'),
  //     meta: {title: '添加菜单'},
  //     hidden: true
  //   }, {
  //     path: 'updateMenu',
  //     name: 'updateMenu',
  //     component: () => import('@/views/ums/menu/update'),
  //     meta: {title: '修改菜单'},
  //     hidden: true
  //   }, {
  //     path: 'resource',
  //     name: 'resource',
  //     component: () => import('@/views/ums/resource/index'),
  //     meta: {title: '资源列表', icon: 'ums-resource'}
  //   }, {
  //     path: 'resourceCategory',
  //     name: 'resourceCategory',
  //     component: () => import('@/views/ums/resource/categoryList'),
  //     meta: {title: '资源分类'},
  //     hidden: true
  //   }]
  // },
  {path: '',
  component: Layout,
  redirect: '/sourceList',
  name:'sourceClass',
  meta: {title: '教学资源系统', icon: 'ums'},
  alwaysShow:true,
  children: [
    {
      path: 'sourceList',
      name: 'sourceList',
      component: () => import('@/views/sourceClass/index.vue'),
      meta: {
        title: '教学资源列表',
        icon: 'home'
      }
    },
    {
      path: 'sourceDetail',
      name: 'sourceDetail',
      component: () => import('@/views/sourceClass/classDetail.vue'),
      meta: {
        title: '教学资源系统详情',
        icon: 'home'
      }
    },
  ]
},
  {
    path: '/managems',
    component: Layout,
    redirect: 'studentFile',
    name: 'managems',
    meta: {title: '教学管理系统', icon: 'ums'},
    alwaysShow:true,
    children:[
      {
        path: 'studentFile',
        name: 'studentFile',
        component: () => import('@/views/managems/student/studentFile.vue'),
        meta: {
          title: '学生档案管理',
          icon: 'home'
        }
      },
      {
        path: 'studentFileAdd',
        name: 'studentFileAdd',
        component: () => import('@/views/managems/student/studentFileAdd.vue'),
        meta: {
          title: '添加学生档案',
          icon: 'home'
        },
        hidden:true
      },
      {
        path: 'studentWorkList',
        name: 'studentWorkList',
        component: () => import('@/views/managems/student/studentWork.vue'),
        meta: {
          title: '学生作品',
          icon: 'home'
        },
        hidden:true
      }
    ]
  },
  // 评价系统
  {
    path: '/commentms',
    component: Layout,
    redirect: 'multipleComment',
    name: 'commentms',
    meta: {title: '教学评价系统', icon: 'ums'},
    children:[
      {
        path: 'multipleComment',
        name: 'multipleComment',
        component: () => import('@/views/commentms/multiple.vue'),
        meta: {
          title: '综合性评价',
          icon: 'home'
        },
      },
      {
        path: 'scoreComment',
        name: 'scoreComment',
        component: () => import('@/views/commentms/score.vue'),
        meta: {
          title: '诊断性评价',
          icon: 'home'
        },
      },
      {
        path: 'processComment',
        name: 'processComment',
        component: () => import('@/views/commentms/process.vue'),
        meta: {
          title: '过程性评价',
          icon: 'home'
        },
      },
      {
        path: 'teacherComment',
        name: 'teacherComment',
        component: () => import('@/views/commentms/teacher.vue'),
        meta: {
          title: '教师与自我评价',
          icon: 'home'
        },
      },
      {
        path: 'addComment',
        name: 'addComment',
        component: () => import('@/views/commentms/addComment.vue'),
        meta: {
          title: '添加学生评价',
          icon: 'home'
        },
      },
      {
        path: 'commentDetail',
        name: 'commentDetail',
        component: () => import('@/views/commentms/commentDetail.vue'),
        meta: {
          title: '评价详情',
          icon: 'home'
        },
      }
    ]
  },
  // 校本系统
  {
    path: '/schoolBasems',
    component: Layout,
    redirect: 'classList',
    name: 'schoolBasems',
    meta: {title: '校本课程系统', icon: 'ums'},
    alwaysShow:true,
    children:[
      {
        path: 'classList',
        name: 'classList',
        component: () => import('@/views/schoolBasems/classList.vue'),
        meta: {
          title: '校本课程列表',
          icon: 'home'
        }
      },
      {
        path: 'teacherClass',
        name: 'teacherClass',
        component: () => import('@/views/schoolBasems/teacherclass.vue'),
        meta: {
          title: '老师课件记录',
          icon: 'home'
        }
      },
      {
        path: 'uploadPreparations',
        name: 'uploadPreparations',
        component: () => import('@/views/schoolBasems/uploadPreparation.vue'),
        meta: {
          title: '上传课件',
          icon: 'home'
        }
      },
      {
        path: 'classDetail',
        name: 'classDetail',
        component: () => import('@/views/schoolBasems/classDetail.vue'),
        meta: {
          title: '课程详情',
          icon: 'home'
        }
      },
      {
        path: 'courseWareAdd',
        name: 'courseWareAdd',
        component: () => import('@/views/schoolBasems/courseWare/index.vue'),
        meta: {
          title: '课件管理',
          icon: 'home'
        }
      },
    ]
  },
  // 教师备课系统
  {
    path: '/preparationms',
    component: Layout,
    redirect: 'teacherPreparation',
    name: 'preparationms',
    meta: {title: '教师备课系统', icon: 'ums'},
    alwaysShow:true,
    children:[
      // {
      //   path: 'collectClassList',
      //   name: 'collectClassList',
      //   component: () => import('@/views/preparationms/collectClassList.vue'),
      //   meta: {
      //     title: '我的收藏',
      //     icon: 'home'
      //   }
      // },
      {
        path: 'classExchange',
        name: 'classExchange',
        component: () => import('@/views/preparationms/classExchange.vue'),
        meta: {
          title: '课程兑换记录',
          icon: 'home'
        }
      },
      
      {
        path: 'intergral',
        name: 'intergral',
        component: () => import('@/views/preparationms/intergral.vue'),
        meta: {
          title: '钻石记录',
          icon: 'home'
        }
      }
    ]
  },
  {
    path: '/aihelp',
    component: Layout,
    redirect: 'aihelpAll',
    name: 'aihelp',
    meta: {title: 'AI辅助', icon: 'ums'},
    alwaysShow:true,
    children:[
      {
        path: 'aihelpAll',
        name: 'aihelpAll',
        component: () => import('@/views/AIhelp/index.vue'),
        meta: {
          title: 'AI辅助',
          icon: 'home'
        }
      },
    ]
  },
    {
    path: '/teachTools',
    component: Layout,
    redirect: 'timeTool',
    name: 'teachTools',
    meta: {title: '教学辅助工具', icon: 'ums'},
    alwaysShow:true,
    children:[
        {
         path: 'timeTool',
         name: 'timeTool',
         component: () => import('@/views/tools/timeTool/index.vue'),
         meta: {
           title: '秒表工具',
           icon: 'home'
         }
       }
    ]
  },
      {
    path: '/liveStreams',
    component: Layout,
    redirect: 'liveStream',
    name: 'liveStreams',
    meta: {title: '电商直播模拟系统', icon: 'ums'},
     alwaysShow:true,
    children:[
        {
         path: 'liveStream',
         name: 'liveStream',
         component: () => import('@/views/liveStream/index.vue'),
         meta: {
           title: '电商直播模拟系统',
           icon: 'home'
         }
       }
    ]
  },
  {path: '*', redirect: '/404', hidden: true}
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}), routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js